import { STEPSLIST } from '../constants';

const INITIAL_STEP = 0;

export const initialState = {
  totalSteps: Object.keys(STEPSLIST).length,
  currentStep: INITIAL_STEP,
  isLastStep: false,
  visitedSteps: [],
  allStepsCompleted: false,
  loading: false,
};

const actionTypes = {
  SET_NEXT: 'SET_NEXT',
  SET_PREV: 'SET_PREV',
  SET_STEP: 'SET_STEP',
  SUBMITTED: 'SUBMITTED',
  LOADING: 'LOADING',
  CLEAR_LOADING: 'CLEAR_LOADING',
  RESET_FORM: 'RESET_FORM',
} as const;

export const actions = {
  setNext: () => ({
    type: actionTypes.SET_NEXT,
  }),
  setPrev: () => ({
    type: actionTypes.SET_PREV,
  }),
  setStep: (step: number) => ({
    type: actionTypes.SET_STEP,
    payload: step,
  }),
  setSubmitted: () => ({
    type: actionTypes.SUBMITTED,
  }),
  setLoading: () => ({
    type: actionTypes.LOADING,
  }),
  clearLoading: () => ({
    type: actionTypes.CLEAR_LOADING,
  }),
  resetForm: () => ({
    type: actionTypes.RESET_FORM,
  }),
} as const;

type actionType = typeof actions;
type wizardActions = ReturnType<actionType[keyof actionType]>;

export const reducer = (state: typeof initialState, action: wizardActions) => {
  switch (action.type) {
    case actionTypes.SET_NEXT:
      return {
        ...state,
        loading: false,
        currentStep: state.currentStep + 1,
        isLastStep: state.currentStep + 1 === state.totalSteps,
        visitedSteps: state.visitedSteps.includes(state.currentStep)
          ? state.visitedSteps
          : [...state.visitedSteps, state.currentStep],
      };
    case actionTypes.SET_PREV:
      return {
        ...state,
        loading: false,
        currentStep: state.currentStep > 0 ? state.currentStep - 1 : 0,
        isLastStep: false,
        visitedSteps: state.visitedSteps.includes(state.currentStep)
          ? state.visitedSteps
          : [...state.visitedSteps, state.currentStep],
      };
    case actionTypes.SET_STEP:
      return {
        ...state,
        loading: false,
        currentStep: action.payload,
        isLastStep: action.payload === state.totalSteps,
        visitedSteps: state.visitedSteps.includes(state.currentStep)
          ? state.visitedSteps
          : [...state.visitedSteps, state.currentStep],
      };
    case actionTypes.SUBMITTED:
      return {
        ...state,
        loading: false,
        visitedSteps: state.visitedSteps.includes(state.currentStep)
          ? state.visitedSteps
          : [...state.visitedSteps, state.currentStep],
        allStepsCompleted: true,
      };
    case actionTypes.LOADING:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.CLEAR_LOADING:
      return {
        ...state,
        loading: false,
      };
    case actionTypes.RESET_FORM:
      return initialState;
    default:
      return initialState;
  }
};
